import { DocumentTemplatesList } from 'pages/secretary/document_templates';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'document_templates',
  label: 'Templates de Documentos',
  list: DocumentTemplatesList,
  actions: ['list', 'show', 'edit'],
  parentName: 'secretary'
};

export default generateResources(resource);
